module.exports = __webpack_public_path__ + "static/media/timer-collect.4bd6cdd0.png";